import React from 'react';
import '../../css/error-pages.css';
import pbgLogoBlue from '../../img/keytravel-logo-blue.png';

export default () => (
  <div className="error-wrapper error-404">
    <div className="header">
      <a href="/" title="Key Travel">
        <img src={pbgLogoBlue} alt="Key Travel" />
      </a>
    </div>
    <div className="floater" />
    <div className="dialog">
      <h1>404</h1>
      <p className="description">
        Sorry to break this to ya,<br />
        but this page doesn't exist. &lt;/3
      </p>
    </div>
  </div>
);




// WEBPACK FOOTER //
// ./src/desktop/components/error-pages/not-found.js